module.exports = __webpack_public_path__ + "img/11.1b8e8daa.gif";